// Languages for the whisper model

export const languages = [
  { name: "English", id: "en" },
  { name: "中文", id: "zh" },
  { name: "हिन्दी", id: "hi" },
  { name: "Español", id: "es" },
  { name: "العربية", id: "ar" },
  { name: "Français", id: "fr" },
  { name: "Português", id: "pt" },
  { name: "русский", id: "ru" },
  { name: "Deutsch", id: "de" },
  { name: "日本語", id: "ja" },
  { name: "한국어", id: "ko" },
  { name: "Italiano", id: "it" },
  { name: "Nederlands", id: "nl" },
];
